import { useEffect } from 'react';

/** The suffix every page shares. Matches `index.html`'s static `<title>`. */
const APP_NAME = 'Integrity :: Business Partner';

/**
 * Sets the browser tab title for the page that calls it.
 *
 * ============================================================================
 * WHY THIS EXISTS
 * ============================================================================
 *
 * Found during the P10 sweep. Seven pages assigned `document.title` directly, each repeating the
 * ` · Integrity :: Business Partner` suffix as a literal, and six pages set nothing at all — so
 * navigating from Business Partners to AI Search left the tab still reading "Business Partners".
 * Browser history entries and bookmarks inherited the wrong name.
 *
 * One hook, one suffix, and every routed page calls it.
 *
 * The title is deliberately NOT restored on unmount: the next page sets its own on mount, and
 * restoring first would flash the previous title. The one case with no successor — closing the tab —
 * does not care.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${APP_NAME}` : APP_NAME;
  }, [title]);
}
